import type { ShirtSizeIdGroup } from './shirt-sizes';
import { buildShirtSizeIdGroup } from './shirt-sizes';

export type AnniversaryOrderRow = {
  slug: string;
  year: number;
  product: string;
  requiresColor: boolean;
};

export const ANNIVERSARY_ORDER_ITEMS: readonly AnniversaryOrderRow[] = [
  { slug: 'ann1', year: 1, product: 'Maroon T-Shirt', requiresColor: false },
  { slug: 'ann2', year: 2, product: 'Sage T-Shirt', requiresColor: false },
  { slug: 'ann3', year: 3, product: 'Deep Teal T-Shirt', requiresColor: false },
  { slug: 'ann4', year: 4, product: 'Dark Lavender T-Shirt', requiresColor: false },
  { slug: 'ann5', year: 5, product: 'Polo with choice of color', requiresColor: true },
  { slug: 'ann6', year: 6, product: 'Crewneck', requiresColor: false },
  { slug: 'ann7', year: 7, product: 'Half Zipped Sweater', requiresColor: false },
  { slug: 'ann8', year: 8, product: 'Jacket', requiresColor: false },
];

export type AnniversaryQuestionIds = { yn: string; color?: string } & ShirtSizeIdGroup;

export function getAnniversaryQuestionIds(
  prefix: string,
  slug: string,
  requiresColor: boolean,
): AnniversaryQuestionIds {
  const base = `${prefix}-shirts-${slug}`;
  const sizes = buildShirtSizeIdGroup(prefix, slug);
  const out: AnniversaryQuestionIds = {
    yn: `${base}-yn`,
    ...sizes,
  };
  if (requiresColor) out.color = `${base}-color`;
  return out;
}
